(function () {
  'use strict';

  var deliveryElements = new Set();
  var deliveryTimer = null;

  function addBusinessDays(date, days) {
    var result = new Date(date.getTime());
    var added = 0;
    while (added < days) {
      result.setDate(result.getDate() + 1);
      if (result.getDay() !== 0 && result.getDay() !== 6) added += 1;
    }
    return result;
  }

  function normalizeStart(date, cutoff) {
    var result = new Date(date.getTime());
    var day = result.getDay();

    if (day === 6) result.setDate(result.getDate() + 2);
    else if (day === 0) result.setDate(result.getDate() + 1);
    else if (result.getHours() >= cutoff) result = addBusinessDays(result, 1);

    result.setHours(9, 0, 0, 0);
    return result;
  }

  function formatDate(date) {
    try {
      return new Intl.DateTimeFormat('de-DE', {
        weekday: 'short',
        day: '2-digit',
        month: '2-digit'
      }).format(date);
    } catch (error) {
      return date.toLocaleDateString('de-DE');
    }
  }

  function countdownText(now, cutoff) {
    var day = now.getDay();
    if (day === 0 || day === 6 || now.getHours() >= cutoff) {
      return 'Bearbeitung am nächsten Werktag';
    }

    var end = new Date(now.getTime());
    end.setHours(cutoff, 0, 0, 0);
    var minutes = Math.max(0, Math.floor((end.getTime() - now.getTime()) / 60000));
    var hours = Math.floor(minutes / 60);
    var remainingMinutes = minutes % 60;
    return 'Noch ' + hours + ' Std. ' + String(remainingMinutes).padStart(2, '0') + ' Min. für Bearbeitung heute';
  }

  function updateDelivery(element) {
    if (!element || !element.isConnected) {
      deliveryElements.delete(element);
      return;
    }

    var available = element.dataset.available === 'true';
    var cutoff = parseInt(element.dataset.cutoff || '14', 10);
    var minDays = parseInt(element.dataset.minDays || '1', 10);
    var maxDays = parseInt(element.dataset.maxDays || '3', 10);
    var dateElement = element.querySelector('[data-delivery-date]');
    var noteElement = element.querySelector('[data-order-message]');
    var countdownElement = element.querySelector('[data-delivery-countdown]');

    if (!available) {
      element.classList.add('is-unavailable');
      if (dateElement) dateElement.textContent = 'Liefertermin derzeit nicht verfügbar';
      if (noteElement) noteElement.textContent = 'Bitte informieren Sie sich über die Wiederverfügbarkeit.';
      if (countdownElement) countdownElement.textContent = '';
      return;
    }

    element.classList.remove('is-unavailable');
    var now = new Date();
    var start = normalizeStart(now, cutoff);
    var earliest = addBusinessDays(start, minDays);
    var latest = addBusinessDays(start, maxDays);
    var dateText = formatDate(earliest) + ' – ' + formatDate(latest);
    var noteText = 'Versand mit Sendungsverfolgung aus Deutschland.';
    var countdown = countdownText(now, cutoff);

    if (dateElement && dateElement.textContent !== dateText) dateElement.textContent = dateText;
    if (noteElement && noteElement.textContent !== noteText) noteElement.textContent = noteText;
    if (countdownElement && countdownElement.textContent !== countdown) countdownElement.textContent = countdown;
  }

  function runDeliveryUpdates() {
    deliveryElements.forEach(updateDelivery);
    if (deliveryElements.size === 0 && deliveryTimer) {
      window.clearInterval(deliveryTimer);
      deliveryTimer = null;
    }
  }

  function initDelivery(element) {
    if (element.dataset.uyDeliveryInitialized === 'true') return;
    element.dataset.uyDeliveryInitialized = 'true';
    deliveryElements.add(element);
    updateDelivery(element);

    if (!deliveryTimer) deliveryTimer = window.setInterval(runDeliveryUpdates, 60000);
  }

  function initTabs(root) {
    if (root.dataset.uyTabsInitialized === 'true') return;
    root.dataset.uyTabsInitialized = 'true';

    root.addEventListener('click', function (event) {
      var button = event.target.closest('[data-uy-tab]');
      if (!button || !root.contains(button)) return;

      var id = button.dataset.uyTab;
      root.querySelectorAll('[data-uy-tab]').forEach(function (item) {
        var active = item === button;
        item.classList.toggle('is-active', active);
        item.setAttribute('aria-selected', active ? 'true' : 'false');
      });
      root.querySelectorAll('[data-uy-panel]').forEach(function (panel) {
        panel.classList.toggle('is-active', panel.dataset.uyPanel === id);
      });
    });
  }

  function initStickyBar(bar) {
    if (bar.dataset.uyStickyInitialized === 'true') return;
    bar.dataset.uyStickyInitialized = 'true';

    var productScope = bar.closest('.product') || document;
    var mainButton = productScope.querySelector('.product-form__submit');
    var price = productScope.querySelector('.product__info-container .price');
    var stickyButton = bar.querySelector('[data-uy-sticky-add]');
    var stickyPrice = bar.querySelector('[data-uy-sticky-price]');

    if (!mainButton || !stickyButton) return;

    function syncState() {
      stickyButton.disabled = mainButton.disabled;
      if (stickyPrice && price) {
        var nextPrice = price.textContent.trim().replace(/\s+/g, ' ');
        if (stickyPrice.textContent !== nextPrice) stickyPrice.textContent = nextPrice;
      }
    }

    syncState();
    stickyButton.addEventListener('click', function () {
      if (!mainButton.disabled) mainButton.click();
    });

    if ('IntersectionObserver' in window) {
      var intersectionObserver = new IntersectionObserver(function (entries) {
        var entry = entries[0];
        if (entry) bar.classList.toggle('is-visible', !entry.isIntersecting);
      }, { threshold: 0.1 });
      intersectionObserver.observe(mainButton);
    }

    // Only watch the original controls. Never observe the full product container,
    // because the sticky bar itself lives there and would create a feedback loop.
    if ('MutationObserver' in window) {
      var buttonObserver = new MutationObserver(syncState);
      buttonObserver.observe(mainButton, { attributes: true, attributeFilter: ['disabled', 'class'] });

      if (price) {
        var priceObserver = new MutationObserver(syncState);
        priceObserver.observe(price, { childList: true, subtree: true, characterData: true });
      }
    }
  }

  function initAll(root) {
    var scope = root || document;
    scope.querySelectorAll('[data-uy-delivery-estimate]').forEach(initDelivery);
    scope.querySelectorAll('[data-uy-product-tabs]').forEach(initTabs);
    scope.querySelectorAll('[data-uy-mobile-atc]').forEach(initStickyBar);
  }

  function start() {
    initAll(document);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });

  document.addEventListener('shopify:section:unload', function () {
    runDeliveryUpdates();
  });
})();
